<template>
  <div class="text-left">
    <mdb-btn @click="$emit('cancel')" icon="arrow-left">Back to List</mdb-btn>
    <mdb-card class="mb-4">
      <mdb-card-header color="secondary">
        {{ suggestion.title }}
      </mdb-card-header>
      <mdb-card-body>
        <div>
          <mdb-btn @click="followToggle()" icon="eye" rounded size="sm" v-if="!suggestion.following">Follow the Discussion</mdb-btn>
          <mdb-btn @click="followToggle()" icon="eye-slash" rounded size="sm" v-if="suggestion.following">Stop Following</mdb-btn>
          <mdb-btn @click="deleteModal = true" icon="trash" color="danger" rounded size="sm" v-if="currentGroup.role =='Admin'">Remove Suggestion</mdb-btn>
          <mdb-btn @click="convert" icon="plus-circle" color="success" rounded size="sm" v-if="currentGroup.role =='Admin' || currentGroup.role == 'Group Organizer'">Convert to Event</mdb-btn>
        </div>
        <div class="md-form">
          <div>
            <gp-avatar :avatar="suggestion.createdByAvatar" :memberId="suggestion.createdById" :size="50"/>
            <span class="text-info">Suggested by {{ suggestion.createdByName }}</span>
          </div>
          <div style="clear:both;"/>
          <input class="form-control form-check-input" disabled id="willingToHost" type="checkbox"
                 v-model="suggestion.willingToHost"/>
          <label for="willingToHost">{{ suggestion.createdByName }} is willing to host this event </label>
        </div>
        <mdb-card class="mb-4">
          <mdb-card-header color="secondary"><h5>Description of Suggestion</h5></mdb-card-header>
          <mdb-card-body>
            <div class="text-info h5" v-if="suggestion.displayStartDate">
              Suggested for {{suggestion.displayStartDate}}
            </div>
            <div v-html="suggestion.description"/>
          </mdb-card-body>
        </mdb-card>

        <mdb-card>
          <mdb-card-header color="secondary">
            <h5>Venue</h5>
          </mdb-card-header>
          <mdb-card-body>
            <mdb-input disabled id="v0" label="A Place We've Been Before" name="v0" radioValue="existing" type="radio"
                       v-model="venueMode"/>
            <mdb-input disabled id="v1" label="A New Place" name="v1" radioValue="new" type="radio"
                       v-model="venueMode"/>

            <div class="md-form text-info" v-if="venueMode == 'existing'">
              <h5>{{ suggestion.venueName }}</h5>
            </div>
            <div class="md-form" v-if="venueMode == 'new'">
              <div v-html="suggestion.newVenueDescription"></div>
            </div>
          </mdb-card-body>
        </mdb-card>
      </mdb-card-body>
    </mdb-card>
    <messaging :id="suggestion.id" type="suggestion"></messaging>
    <yes-no-modal question="Are you sure you wish to remove this suggestion?" v-if="deleteModal" @yes="doDelete" @no="deleteModal=false"/>
    <yes-no-modal question="Are you sure you wish to convert this suggestion?" additional-text="A new draft event will be created and the suggestion will be removed."
                  v-if="convertModal" @yes="doConvert" @no="convertModal=false"/>
  </div>
</template>

<script>
import {mdbBtn, mdbCard, mdbCardBody, mdbCardHeader, mdbInput} from 'mdbvue';
import gpAvatar from "../common/Avatar";
import Messaging from "../common/Messaging";
import api from "../../services/groupsPlaceApi";
import YesNoModal from "../common/YesNoModal";

export default {
  name: 'Suggestion-Editor',
  components: {
    YesNoModal,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbBtn,
    mdbInput,
    gpAvatar,
    Messaging
  },
  props: {
    suggestion: {
      type: Object,
      default: null
    }
  },
  mounted() {
    if (this.suggestion.newVenueDescription) this.venueMode = "new";
  },
  watch: {
    venueMode(n, o) {
      if (n == "new") this.suggestion.venueId = null
      if (n == "existing") this.suggestion.newVenueDescription = null
    }
  },
  computed: {
    userDetails: function () {
      return this.$store.state.userDetails
    },
    currentGroup: function () {
      return this.$store.state.currentGroup
    }
  },
  data() {
    return {
      venueMode: "existing",
      deleteModal: false,
      convertModal: false
    }
  },
  methods: {
    followToggle() {
      this.$store.dispatch("setExecuting", true);
      api.post("/event/suggestionFollow/" + this.suggestion.id, {following: !this.suggestion.following}).then(
        (results) => {
          this.suggestion.following = !this.suggestion.following
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    convert() {
      this.convertModal = true
    },
    doConvert() {
      this.convertModal = false
      this.$store.dispatch("setExecuting", true);
      api.post("/event/suggestionConvert/" + this.suggestion.id, {}).then(
        (results) => {
          this.$router.push("/event/show/" + results.data.id)
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    doDelete() {
      this.deleteModal = false
      this.$store.dispatch("setExecuting", true);
      api.delete("/event/suggestion/" + this.suggestion.id).then(
        () => {
          this.$emit("reload")
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
}
</script>
